module.exports = __webpack_public_path__ + "img/x-lg.6a06956b.svg";